export const PATHS = {
  // Auth (no layout)
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  AUTH_CALLBACK: '/auth/callback',

  // Panel routes (map + side panel)
  DASHBOARD: '/dashboard',
  VESSELS: '/vessels',
  VESSEL_DETAIL: '/vessels/:vesselId',
  VESSEL_PROFILE: '/vessels/:vesselId/profile',
  VESSEL_ACCOUNT: '/vessels/:vesselId/account',
  HOLDINGS: '/vessels/:vesselId/holdings',
  VESSEL_ORDERS: '/vessels/:vesselId/orders',
  VESSEL_ORDER_DETAIL: '/vessels/:vesselId/orders/:orderId',
  VESSEL_UPDATES: '/vessels/:vesselId/updates',
  VESSEL_UPDATES_REQUEST: '/vessels/:vesselId/updates/request',
  CATALOG: '/catalog',
  BASKET: '/basket',
  BASKET_ROUTE_CREATE: '/basket/createRoute',
  BASKET_IMPORT: '/basket/import',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:orderId',
  ROUTES: '/vessels/:vesselId/routes',
  ROUTE_CREATE: '/vessels/:vesselId/routes/create',
  ROUTE_EDIT: '/vessels/:vesselId/routes/:routeId/edit',
  ROUTE_DETAIL: '/vessels/:vesselId/routes/:routeId',
  ROUTE_PRODUCTS: '/vessels/:vesselId/routes/:routeId/products',

  // Fullscreen routes (no map)
  SETTINGS: '/settings',

  // Admin routes
  ADMIN: '/admin',
  ADMIN_TENANTS: '/admin/tenants',
  ADMIN_DISTRIBUTORS: '/admin/distributors',
  ADMIN_AGENTS: '/admin/agents',
  ADMIN_COMPANIES: '/admin/companies',
  ADMIN_VESSELS: '/admin/vessels',
  ADMIN_USERS: '/admin/users',
  ADMIN_HOLDING_TEMPLATES: '/admin/holding-templates',
  ADMIN_HOLDING_TEMPLATE_DETAIL: '/admin/holding-templates/:templateId',
} as const;
